export default __webpack_public_path__ + "static/media/arrow_down_bold.f9809835.svg";